import { RequestStatus, type RequestMetadata } from "../../../models/Request";
import { INACTIVE_REQUEST_STATUSES } from "../constants";

export const isActiveRequestMetadata = (metadata: RequestMetadata): boolean => {
  if (metadata.id < 0) {
    return true;
  }

  return !INACTIVE_REQUEST_STATUSES.includes(metadata.status);
};

export const hasActiveRequestOrDraft = (
  metadata: RequestMetadata[] | undefined
) => !!metadata?.some(isActiveRequestMetadata);

export const hasRegisteredRequest = (
  metadata: RequestMetadata[] | undefined
) =>
  !!metadata?.some((request) => request.status === RequestStatus.Registered);
